import currency from 'currency.js';

import { Question } from '@styled-icons/remix-fill';
import { FileText } from '@styled-icons/remix-line';

import theme from 'styles/theme';
import * as S from './styles';

const PROCESSING_FEE = 0.3;

type CardBreakdownTableProps = {
  debit: number;
  creditCardFee?: number;
};

const CardBreakdownTable = ({
  debit,
  creditCardFee = 0.029,
}: CardBreakdownTableProps) => {
  const fees = debit * creditCardFee + PROCESSING_FEE;
  const totalPaid = debit * (1 + creditCardFee) + PROCESSING_FEE;

  return (
    <div>
      <S.DebitValue>
        Your credit card will be charged:{' '}
        <span>{currency(totalPaid).format()}</span>
      </S.DebitValue>
      <S.TableTitle>
        <FileText size={14} color={theme.colors.neutralGray40} />
        <p>Payment details</p>
      </S.TableTitle>
      <S.Table>
        <tbody>
          <tr>
            <S.Td>Installment payment</S.Td>
            <S.Td align="right">{currency(debit).format()}</S.Td>
          </tr>
          <tr>
            <S.Td>
              Processing fees
              <S.Tooltip
                color={theme.colors.purple100}
                title="Credit Card transactions have 2.9% + 30¢ processing fees"
              >
                <Question size={20} color={theme.colors.purple50} />
              </S.Tooltip>
            </S.Td>
            <S.Td align="right">{currency(fees).format()}</S.Td>
          </tr>
          <tr>
            <S.Td>You total paid</S.Td>
            <S.Td align="right" isTotal>
              {currency(totalPaid).format()}
            </S.Td>
          </tr>
        </tbody>
      </S.Table>
    </div>
  );
};

export default CardBreakdownTable;
